import IfUserRoles from '@src/components/common/role/IfUserRoles';
import AdminDashboardContainer from '@src/components/dashboard/AdminDashboardContainer';
import TraineeDashboardContainer from '@src/components/dashboard/TraineeDashboardContainer';
import { UserRoleEnum } from '@src/model/user/UserRole';
import React from 'react';

const DashboardPage = () => (
  <React.Fragment>
    {/* ----- Trainee dashboard ----- */}
    <IfUserRoles roles={[UserRoleEnum.TRAINEE, UserRoleEnum.COURSE_CREATOR]} fallback="">
      <TraineeDashboardContainer />
    </IfUserRoles>

    {/* ----- Admin dashboard ----- */}
    <IfUserRoles roles={[UserRoleEnum.ORGANIZATION_ADMIN, UserRoleEnum.SUPERADMIN]} fallback="">
      <AdminDashboardContainer />
    </IfUserRoles>
  </React.Fragment>
);

export default DashboardPage;
